// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_hEu-y","key-features":"key-features_fCtIy","item-title":"item-title_YVnaQ"};